import "./RunSheet.css";
import { useRef, type ReactNode } from "react";
import { useModalFocus } from "@/hooks/useModalFocus";
export function RunSheet({
  title,
  children,
  close,
}: {
  title: string;
  children: ReactNode;
  close: () => void;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useModalFocus(ref, true, close, "drawer");
  return (
    <div className="run-scrim" onMouseDown={(e) => e.target === e.currentTarget && close()}>
      <div ref={ref} className="run-sheet" role="dialog" aria-modal="true" aria-label={title}>
        <header>
          <h2>{title}</h2>
          <button onClick={close} aria-label={`Close ${title}`}>
            ×
          </button>
        </header>
        {children}
      </div>
    </div>
  );
}
